import { IconProps, Icon } from "@chakra-ui/icon";

const BuildingOutlinedIcon = (props: IconProps) => {
  return (
    <Icon
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path opacity="0.12" d="M10 9.83334H6V14.5H10V9.83334Z" fill="currentColor" />
      <path
        d="M10 14.5V10.9C10 10.5266 10 10.3399 9.92734 10.1973C9.86342 10.0719 9.76144 9.96991 9.63599 9.906C9.49339 9.83333 9.3067 9.83333 8.93333 9.83333H7.06667C6.6933 9.83333 6.50661 9.83333 6.36401 9.906C6.23856 9.96991 6.13658 10.0719 6.07266 10.1973C6 10.3399 6 10.5266 6 10.9V14.5M12.6667 14.5V4.63333C12.6667 3.8866 12.6667 3.51323 12.5213 3.22801C12.3935 2.97713 12.1895 2.77316 11.9387 2.64532C11.6534 2.5 11.2801 2.5 10.5333 2.5H5.46667C4.71993 2.5 4.34656 2.5 4.06135 2.64532C3.81046 2.77316 3.60649 2.97713 3.47866 3.22801C3.33333 3.51323 3.33333 3.8866 3.33333 4.63333V14.5M14 14.5H2M6.33333 5.83333H6.34M9.66667 5.83333H9.67333M6.66667 5.83333C6.66667 6.01743 6.51743 6.16667 6.33333 6.16667C6.14924 6.16667 6 6.01743 6 5.83333C6 5.64924 6.14924 5.5 6.33333 5.5C6.51743 5.5 6.66667 5.64924 6.66667 5.83333ZM10 5.83333C10 6.01743 9.85076 6.16667 9.66667 6.16667C9.48257 6.16667 9.33333 6.01743 9.33333 5.83333C9.33333 5.64924 9.48257 5.5 9.66667 5.5C9.85076 5.5 10 5.64924 10 5.83333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default BuildingOutlinedIcon;
